import React, { Fragment, useState } from 'react';
import useDataApi from 'utils/useDataApi';
import { Alert, ProgressBar, Table } from 'react-bootstrap';
import { DateTime } from 'luxon';


export default function DocketAlerts() {
  // TODO - we don't handle paging in the UI yet...
  const [{ data, isLoading, isError }] = useDataApi(`/rpc/admin/docket-alerts?page_size=1000`);

  if (isLoading) return <ProgressBar now={100} active />;

  if (isError) return (
    <Alert bsStyle="danger">
      There has been an error loading the list of Docket Alerts.
      <pre>
        {`${isError}`}
      </pre>
    </Alert>
  );

  return (
    <Table striped bordered condensed hover>
      <thead>
        <tr>
          <th>Uid</th>
          <th>CaseUUID</th>
          <th>NextRun</th>
          <th>Frequency</th>
          <th>Enaled</th>
        </tr>
      </thead>
      <tbody>{
        data.alerts.map(alert => (
          <tr>
            <td><a href={`/user/${alert.uid}/edit`}>{alert.uid}</a></td>
            <td><a href={`/filings/${alert.case_uuid}`}>{alert.case_uuid}</a></td>
            <td>{
              DateTime
                .fromISO(alert.next_run)
                .setZone(alert.time_zone)
                .toFormat('DDDD t ZZZZ')
            }</td>
            <td>{alert.frequency}</td>
            <td>{alert.enabled && 'Yes'}</td>
          </tr>
        ))
      }
      </tbody>
    </Table>
  );
}



// WEBPACK FOOTER //
// ./src/Admin/DocketAlerts.jsx